<table>
    <thead>
      <tr>
        <th>Element</th>
        <th>Description</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>
            <button (click)="onSuccess()">Success</button>
        </td>
        <td>Success notification button</td>
      </tr>
      <tr>
        <td>
            <button (click)="onError()">Error</button>
        </td>
        <td>Error notification button</td>
      </tr>
      <tr>
        <td>
            <button (click)="onWarning()">Warning</button>
        </td>
        <td>Warning notification button</td>
      </tr>
      <tr>
        <td>
            <button (click)="onInfo()">Info</button>
        </td>
        <td>Info notification button</td>
      </tr>
    </tbody>
  </table>